import React, { useState, useEffect } from "react"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import { withRouter, Link, useHistory } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { URLS } from "Url"
import axios from "axios"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)

  const [form1, setform1] = useState([])

  const history = useHistory()

  useEffect(() => {
    GetProfile()
    const interval = setInterval(() => {
      GetProfile()
    }, 3 * 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const GetProfile = () => {
    var token = datas

    axios
      .post(
        URLS.getProfile,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            setform1(res?.data?.vendorProfile)
          }
        },
        error => {
          if (error.response && error.response.status === 401) {
            LogOut()
          }
        }
      )
  }

  const LogOut = () => {
    history.push("/logout")
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={URLS?.Base + form1?.profilePic}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">
            {form1?.vendorName}
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
